import clsx from "clsx";
import { motion } from "framer-motion";
import PropTypes from "prop-types";
import { useState } from "react";
import Skeleton from "react-loading-skeleton";

import "./expert.icon.scss";

export const ExpertIcon = ({ transfrId, className }) => {
  const icon = `/images/careers/${transfrId}/expert.png`;

  const [loading, setLoading] = useState(true);

  return (
    <div className={clsx("expert-icon-container", className)}>
      <motion.img
        src={icon}
        alt="Expert icon"
        animate={{ opacity: loading ? 0 : 1 }}
        onLoad={() => setLoading()}
        className={clsx(loading && "loading")}
      />
      {loading && (
        <Skeleton
          height="inherit"
          width="inherit"
          circle
          containerClassName="tx-skeleton-container"
        />
      )}
    </div>
  );
};

ExpertIcon.displayName = "Expert Icon";

ExpertIcon.propTypes = {
  transfrId: PropTypes.string,
  className: PropTypes.string,
};
